module.exports = __webpack_public_path__ + "img/delete.2662fc3a.svg";